import { render, staticRenderFns } from "./MyCourseList.vue?vue&type=template&id=35d253ca&scoped=true&"
import script from "./MyCourseList.vue?vue&type=script&lang=js&"
export * from "./MyCourseList.vue?vue&type=script&lang=js&"
import style0 from "./MyCourseList.vue?vue&type=style&index=0&id=35d253ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d253ca",
  null
  
)

export default component.exports